import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import responseKeyNormalizerMapping from './mapping';
import MarketFunctionBarService from './service/MarketFunctionBarService';
import MarketOperationService from './service/MarketOperationService';
export default class MarketDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return MarketOperationService;
    }
    get FunctionBarServiceClass() {
        return MarketFunctionBarService;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 5,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailMarketRoot' },
        };
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(location) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(location),
            };
        }
        return {
            path: 'market',
            name: 'detailMarketRoot',
            redirect: `${self.PLUGIN_BASIC_PATH}/${this.name}/folders`,
            // @ts-ignore
            component: () => import('./MarketDetail.vue'),
            props: getDetailPageProps,
            children: [
                {
                    path: 'folders',
                    name: 'marketFolderPage',
                    // @ts-ignore
                    component: () => import('./plugin-view/Folder.vue'),
                    props: getDetailPageProps,
                },
            ],
        };
    }
}
